/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createContactBodyPriorityMax = 100;

export const CreateContactBody = zod.object({
  kind: zod.enum(['email', 'telephone']),
  destination: zod.string(),
  label: zod.string(),
  priority: zod.int().min(1).max(createContactBodyPriorityMax),
  smsEnabled: zod.boolean().optional(),
  voiceEnabled: zod.boolean().optional(),
});

export type CreateContactBody = zod.input<typeof CreateContactBody>;
export type CreateContactBodyOutput = zod.output<typeof CreateContactBody>;
